/* FFOCKE: desalienta guardar/arrastrar las imágenes de la tienda (clic derecho, arrastre, pulsación larga). */
(function () {
  var SEL = 'img,picture,.product__media,.product-media-modal,.product__modal-opener,.ff-slides,.ff-pcard,.ff-pmock,.thumbnail';
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(SEL)) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  }, true);
})();
